export default __webpack_public_path__ + "static/media/Statistics_2016_English.7e3148ee.zip";